
/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class SchoolRepo {

    static $resource = 'schools';
    
    constructor($auth){
        $http = new Http($auth);        
    }

    show(id){
        return $http.get(SchoolRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return $http.post(SchoolRepo.$resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(){
        return $http.get(SchoolRepo.$resource).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(page, q, orderBy){
        let query = "page=" + page;
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(SchoolRepo.$resource + "/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data){
        return $http.put(SchoolRepo.$resource + "/" + id, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    delete(id){
        return $http.delete(SchoolRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/repos/SchoolRepo.js